import { render, staticRenderFns } from "./schedulePairDataTeacherViewer.vue?vue&type=template&id=70b77e90&scoped=true&"
import script from "./schedulePairDataTeacherViewer.vue?vue&type=script&lang=js&"
export * from "./schedulePairDataTeacherViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b77e90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VHover,VIcon,VSheet})
